/*
 * Put data-shopify-gtm on container and data-custom-cta on the first CTA container of shopify btn.
 * If you want add a view item event on GTM you need to insert the "view" value into data-shopify-gtm attribute.
*/
const shopifyGTMEvent = () => {
    const shopifyContainerList = document.querySelectorAll("[data-shopify-gtm]");
    if (shopifyContainerList && shopifyContainerList.length > 0) {
        shopifyContainerList.forEach((shopifyContainer) => {
            const buttonContainer = shopifyContainer.querySelector("[data-custom-cta]");
            buttonContainer.classList.add("disabled");
            setTimeout(() => {
                buttonContainer.classList.remove("disabled");
                const iframe = buttonContainer.querySelector("iframe");
                if (iframe) {
                    const buttonIframe = iframe.contentWindow.document.querySelector('html body button.shopify-buy__btn');
                    buttonIframe.addEventListener("click", () => {
                        setTimeout(() => {
                            const iframeContainer = document.querySelector(".shopify-buy-modal-wrapper");
                            const iframeModal = iframeContainer.querySelector("iframe");
                            if (iframeModal) {
                                let title = iframeModal.contentWindow.document.querySelector('.shopify-buy__product__title').innerHTML;
                                let selectedOption = iframeModal.contentWindow.document.querySelector('.shopify-buy__option-select__select option[selected]');
                                let variant = selectedOption ? selectedOption.getAttribute("value") : "";
                                let quantity = parseInt(iframeModal.contentWindow.document.querySelector('.shopify-buy__quantity').getAttribute("value"));
                                let price = parseFloat(iframeModal.contentWindow.document.querySelector('.shopify-buy__product__actual-price').innerHTML.replace("€", "").replace(".", "").replace(",", "."));
                                const button = iframeModal.contentWindow.document.querySelector('.shopify-buy__btn.shopify-buy__beside-quantity[data-element="product.button"]');
                                if (shopifyContainer.getAttribute("data-shopify-gtm") === "view") {
                                    //@ts-ignore - dataLayer comes from GTM
                                    dataLayer.push({ ecommerce: null });
                                    //@ts-ignore - dataLayer comes from GTM
                                    dataLayer.push({
                                        event: "view_item",
                                        ecommerce: {
                                            currency: "EUR",
                                            value: price * quantity,
                                            items: [
                                                {
                                                    item_name: title,
                                                    item_variant: variant,
                                                    price: price,
                                                    quantity: quantity
                                                }
                                            ]
                                        }
                                    });
                                }
                                button.addEventListener("click", () => {
                                    title = iframeModal.contentWindow.document.querySelector('.shopify-buy__product__title').innerHTML;
                                    selectedOption = iframeModal.contentWindow.document.querySelector('.shopify-buy__option-select__select option[selected]');
                                    variant = selectedOption ? selectedOption.getAttribute("value") : "";
                                    quantity = parseInt(iframeModal.contentWindow.document.querySelector('.shopify-buy__quantity').getAttribute("value"));
                                    price = parseFloat(iframeModal.contentWindow.document.querySelector('.shopify-buy__product__actual-price').innerHTML.replace("€", "").replace(".", "").replace(",", "."));
                                    //@ts-ignore - dataLayer comes from GTM
                                    dataLayer.push({ ecommerce: null });
                                    //@ts-ignore - dataLayer comes from GTM
                                    dataLayer.push({
                                        event: "add_to_cart",
                                        ecommerce: {
                                            currency: "EUR",
                                            value: price * quantity,
                                            items: [
                                                {
                                                    item_name: title,
                                                    item_variant: variant,
                                                    price: price,
                                                    quantity: quantity
                                                }
                                            ]
                                        }
                                    });
                                });
                            }
                        }, 1000);
                    });
                }
            }, 3000);
        });
    }
};
